/** Read the same incremental value for the overview and dashboard summary. */
export function getIncrementalRevenue(response: any, index: number): number {
  const incrementalRevenue = Number(response?.incrementalRevenue?.[index]);

  if (Number.isFinite(incrementalRevenue)) return incrementalRevenue;

  const legacyRevenue = Number(
    String(response?.rpv?.revenueOverall?.[index] ?? 0).replace(/\s/g, ''),
  );

  return Number.isFinite(legacyRevenue) ? legacyRevenue : 0;
}
